const FILTER_PASTE_WHITESPACE = /[\s\u200B-\u200D\u2060\uFEFF]+/g;

export function normalizeFilterPasteText(value: string): string {
  return value.replace(FILTER_PASTE_WHITESPACE, '');
}
